import { cn } from '@savvy-kit/lib/utils';

/** Inline validation error text shown beneath a form control. Renders nothing when `message` is empty. */
export function InputErrorMessage({
  message,
  className,
  id,
}: {
  readonly message?: string;
  readonly className?: string;
  /** Target for the control's `aria-describedby`, so screen readers read the error text. */
  readonly id?: string;
}) {
  if (message === undefined || message === '') {
    return null;
  }
  return (
    <span id={id} className={cn('text-destructive text-xs', className)}>
      {message}
    </span>
  );
}
